import { createAction } from '@reduxjs/toolkit';

import { SET_FEATURE_FLAGS, type FeatureFlags } from './types';

export const setFeatureFlags = createAction<FeatureFlags, typeof SET_FEATURE_FLAGS>(SET_FEATURE_FLAGS);
